import { TAccount } from './accounts.types';

/**
 * Determines if an account is loan ended
 * @param account: TAccount- An Account object
 * @returns true or false
 */
export const getAccountIsLoanEnded = (account: TAccount) => {
    return Boolean(account.loan_status === 'ended');
};
